Pollfish.surveyState = (function surveyState() {
  let currentSurveyState = '';
  let currentFailedOutcomeReason = false;

  return {
    setState(state) {
      currentSurveyState = state;
    },
    getState() {
      return currentSurveyState;
    },
    setFailedOutcomeReason(reason) {
      currentFailedOutcomeReason = reason;
    },
    getFailedOutcomeReason() {
      return currentFailedOutcomeReason;
    },
  };
})();

export default Pollfish.surveyState;
